<template>
  <!-- :dark="getDarkMode" :light="!getDarkMode" -->

  <url-rewriter>
    <div class="app-wrapper" :style="appWrapperStyles">
      <v-app class="app" :dark="globalDarkMode" :light="!globalDarkMode">
        <ui-theme>
          <div>
            <transition name="slide-right" mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
        </ui-theme>
      </v-app>
      <div class="app popup-notifier-app v-application v-application--is-ltr" :dark="globalDarkMode" :light="!globalDarkMode">
        <popup-notifier />
      </div>
    </div>
  </url-rewriter>
</template>

<script>
import urlRewriter from "@/_components/core/url-rewriter";
import navMain from "@/_components/layouts/nav-main";
import uiTheme from "@/_components/layouts/ui-theme";
import userSettings from "@/_mixins/user-settings-mixin";
import theme from "@/_config/theme";
import PopupNotifier from "@/_components/shared/popup-notifier.vue";

export default {
  name: "App",
  mixins: [userSettings],
  components: { navMain, uiTheme, urlRewriter, PopupNotifier },
  computed: {
    imageUrl() {
      var imgname = this.globalBackgroundImage;
      var images = theme.backgroundImages.filter((e) => e.name === imgname);
      var ret =
        images.length > 0 ? images[0].url : theme.backgroundImages[0].url;
      return ret;
    },
    appStyles() {
      debugger;
      var ret = {};
      var color = this.globalAppBgColorLight;
      var darkcolor = this.globalAppBgColorDark;
      ret["background-color"] = this.globalDarkMode
        ? `rgba(${darkcolor.r},${darkcolor.g},${darkcolor.b},${darkcolor.a})`
        : `rgba(${color.r},${color.g},${color.b},${color.a})`;
      //  var color = this.appBackgroundColor;
      // ret[
      //   "background-color"
      // ] = `rgba(${color.r},${color.g},${color.b},${color.a})`;
      return ret;
    },
    appWrapperStyles() {
      return { backgroundImage: `url('${this.imageUrl}')` };
    },
    classes() {
      return [this.$vuetify.breakpoint.name];
    },
    mainNavEnabled() {
      return typeof(this.$route.meta.mainNavEnabled) !== typeof(undefined) ? this.$route.meta.mainNavEnabled : true;
    },
  },
  watch: {},
  created() {
   // console.log("main app");
    // Fetch user details when the app is created
   this.$store.dispatch('updateUserDetail');
  },
  data: () => ({
    // image : image,
  }),
  methods: {},
};
</script>

<style lang="scss">
.app-wrapper {
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-color: blue !important;

  // filter: blur(8px);
}

.app {
  // background-size: cover !important;
  // background-position: center center !important;
  // background-repeat: no-repeat !important;
  // background-attachment: fixed !important;
  // box-shadow: inset 0px -80px 50px rgba(0,0,0,0.6),inset 0px 60px 80px rgba(0,0,0,0.6),inset 0px -200px 50px rgba(0,0,0,.7);
  //background-color:rgba(0,0,0,.2) !important;
  // background: linear-gradient(180deg, rgba(0,0,0,0) 80%, rgba(129,129,129,1) 85%, rgba(69,90,100,1) 70%, rgba(69,90,100,1) 100%) !important;
}
</style>
